<template>
	<div class="setUpUnder">
		<layout-gray class="col" gutter="20">
			<Under18Team v-for="(story,i) in createStories" :key="i" :ref="'story'" :num="i" :story="story" :isOnly="(createStories.length == 1)? true : false"></Under18Team>
			<el-button icon="new-button el-icon-circle-plus" @click="addNewStoreis" type="primary" plain>再新增一組小組</el-button>
			<div class="layout-row button-box" align-x="right" gutter="10 ">
				<el-button type="primary" size="mini" @click="nextStep">下一步</el-button>
			</div>
		</layout-gray>
	</div>
</template>

<script>
import LayoutGray from "@/components/challenge/signUp/LayoutGray.vue";
import Under18Team from "@/components/challenge/signUp/Under18Team.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import uuid from "uuid";

export default {
	components: { LayoutGray, Under18Team },
	computed: {
		...mapState("story", ["createStories"])
	},
	methods: {
		...mapMutations("story", ["addNewCreateStories", "cleanCreateStories"]),
		...mapActions("story", ["createStory"]),
		addNewStoreis() {
			// 18歲以下
			// index用來vue render用 再發API前會移除
			let data = { index: uuid.v4(), is_18: false };
			this.addNewCreateStories(data);
		},
		initStories() {
			// 18歲以下
			let data = { index: uuid.v4(), is_18: false };
			this.cleanCreateStories();
			this.addNewCreateStories(data);
		},
		async nextStep() {
			for (let ref of this.$refs.story) {
				if (!ref.validatedAll()) {
					this.$message.error("資料尚未全部填寫完畢");
					return;
				}
			}
			try {
				await this.createStory();
				this.$router.push({ name: "set_up_password" });
			} catch (e) {
				this.$message.error(e);
			}
		}
	},
	created() {
		this.initStories();
	}
};
</script>

<style lang="scss" scoped>
.setUpUnder {
	.new-button {
		border: 1px dashed #57aef1;
		height: 58px;
	}

	.button-box {
		justify-content: flex-end;

		.el-button {
			width: 150px;
			height: 30px;
			margin-left: 10px;
		}
	}
}
</style>
